import { render, staticRenderFns } from "./FilterSocials.vue?vue&type=template&id=4d117240&scoped=true"
import script from "./FilterSocials.vue?vue&type=script&lang=js"
export * from "./FilterSocials.vue?vue&type=script&lang=js"
import style0 from "./FilterSocials.vue?vue&type=style&index=0&id=4d117240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d117240",
  null
  
)

export default component.exports